import clsx from 'clsx'
import React, { memo } from 'react'

const Spinner = ({
  height = '',
  isScreen = false,
  dataTestId = '',
  size = '',
  text = '',
}) => (
  <div
    data-testid={dataTestId}
    className={clsx(
      'flex flex-col items-center justify-center text-gray10',
      isScreen ? 'min-h-screen' : ''
    )}
    style={{ height: height ? `${height}px` : '200px' }}
    role='status'
  >
    <svg
      width={size || '44'}
      height={size || '44'}
      viewBox='0 0 128 128'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className='animate-bounce'
    >
      <rect width='128' height='128' rx='42' fill='currentColor' />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M105.615 82.2172C107.872 76.5871 109 70.3941 109 63.6381C109 56.8016 107.872 50.6488 105.615 45.1796C103.358 39.63 100.206 34.9249 96.1595 31.0643C92.1906 27.2038 87.4436 24.2279 81.9183 22.1367C76.393 20.0456 70.4008 19 63.9416 19C57.4825 19 51.4903 20.0456 45.965 22.1367C40.5175 24.2279 35.7704 27.2038 31.7237 31.0643C27.7549 34.9249 24.642 39.63 22.3852 45.1796C20.1284 50.6488 19 56.8016 19 63.6381C19 70.3941 20.1284 76.5871 22.3852 82.2172C24.642 87.7668 27.7549 92.5523 31.7237 96.5737C35.7704 100.515 40.5175 103.571 45.965 105.743C51.4903 107.914 57.4825 109 63.9416 109C70.4008 109 76.393 107.914 81.9183 105.743C87.4436 103.571 92.1906 100.515 96.1595 96.5737C100.206 92.5523 103.358 87.7668 105.615 82.2172ZM77.2697 73.7532C63.9281 88.0729 46.6678 94.811 38.7179 88.8032C30.7679 82.7953 35.1387 66.3166 48.4803 51.9968C61.8219 37.6771 80.35 28.7422 88.3 34.75C96.2499 40.7578 90.6113 59.4334 77.2697 73.7532Z'
        fill='white'
      />
    </svg>
    {Boolean(text?.length) && (
      <span className='mt-3 font-medium text-gray9 '>{text}</span>
    )}
  </div>
)

export default memo(Spinner)
